/**
 * entity Normalizr Schema
 */
import { schema } from 'normalizr';

const entity = new schema.Entity('entities');

export default entity;
